const init = () => {
  const checklistPrint = document.querySelector('.Checklist-printAction');

  if (checklistPrint) {
      checklistPrint.addEventListener('click', () => {
          window.print();
      });

  }
};

// Init on initial page load
init();
